import { errorTypes } from "../constants/form-error-types";
import { milestoneValidationMessages } from "../forms/milestone.form";

export const getControlValidationMessage = (controlName: string, controlErrors: any, validationMessages: any): string => {
  if(!controlErrors){
    return '';
  }
  if(controlErrors[errorTypes.required]){
    return validationMessages[controlName].required;
  }

  if(controlErrors[errorTypes.email]){
    return validationMessages[controlName].email;
  }

  if(controlErrors[errorTypes.maxlength]){
    return validationMessages[controlName].maxLength;
  }
}
